import React from 'react'
import * as SurveyJS from 'survey-react'

import CaptchaWidgetWrapper from './capatchaWidget'

const CaptchaWidget = {
  name: 'captchawidget',
  title: 'captchawidget',
  iconName: 'icon-default',
  widgetIsLoaded: function() {
    return true
  },
  isFit: function(question) {
    switch (question.name) {
      case 'Xplor_Captcha':
        return true
      default:
        return false
    }
  },
  activatedByChanged: function() {
    SurveyJS.JsonObject.metaData.addClass('captchawidget', [], null, 'html')
  },
  // eslint-disable-next-line react/display-name
  render: question => {
    return <CaptchaWidgetWrapper question={question} />
  }
}

export default CaptchaWidget
